<template>
  <div class="browse-home">
    <onboarding />
    <div class="browse-home__smile">
      <segment :id="smileSegment.id" :isDemo="demo" @demoActivated="id => $emit('demoActivated', id)" />
    </div>
    <dynamic-scroller :items="segments" :min-item-size="30" class="browse-home__segments">
      <template v-slot="{ item, index, active }">
        <dynamic-scroller-item
          :item="item"
          :active="active"
          :data-index="index"
        >
          <segment :key="item.id" :id="item.id" :isDemo="demo" @demoActivated="id => $emit('demoActivated', id)" />
        </dynamic-scroller-item>
      </template>
    </dynamic-scroller>
  </div>
</template>

<script>
export default {
  name: 'browse-home',
  props: {
    demo: Boolean
  },
  computed: {
    smileSegment() {
      return this.$store.getters['contentTree/findSegments']()[0]
    },
    segments() {
      return this.$store.getters['contentTree/findSegments']().slice(1)
    },
    contentTreeFetching() {
      return this.$store.state.contentTree.fetching
    },
    contentTreeSource() {
      return this.$store.state.contentTree.source
    }
  }
}
</script>

<style lang="scss">
.browse-home {
  position: relative;
  padding-bottom: 30px;
  background-color: #F9F9F9;

  &__smile {
    position: relative;
    overflow: hidden;
    padding-bottom: 50px;
    margin-bottom: -56px;
    z-index: 1;
    background-image: url("~@/assets/home-background.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;

    @media (hover: none),
         (max-width: 425px) and (orientation: portrait),
         (max-width: 812px) and (orientation: landscape) {
      padding-bottom: 15px;
      margin-bottom: -16px;
    }
  }

  &__segments {
    z-index: 1;
    margin-top: 16px;
  }
}
</style>
